import api from "./api";

const dashboardService = {
  getSummary: (params) => api.get("/dashboard/summary", { params }),
  getSuperAdminSummary: (params) => api.get("/dashboard/superadmin-summary", { params }),
};

export default dashboardService;

